import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  providerSelect: {
    minWidth: 200,
  },
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - 340px)`,
    overflow: 'auto',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  statusDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    flexShrink: 0,
  },
  statusDotSynced: {
    backgroundColor: theme.palette.success.main,
  },
  statusDotNotSynced: {
    backgroundColor: theme.palette.error.main,
  },
  statusDotUnsaved: {
    backgroundColor: theme.palette.warning.main,
  },
  emptyState: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  threeColumnLayout: {
    display: 'flex',
    gap: theme.spacing(2),
    flex: 1,
    minHeight: 0,
  },
  listColumn: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  jsonColumn: {
    flex: 2,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - 340px)`,
  },
  formColumn: {
    flex: 2,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - 340px)`,
  },
  listItemSelected: {
    backgroundColor: theme.palette.action.selected,
  },
  jsonContent: {
    padding: theme.spacing(2),
    overflow: 'auto',
    flex: 1,
    fontFamily: 'monospace',
    fontSize: 13,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  panelTitle: {
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontWeight: 600,
  },
  formContent: {
    padding: theme.spacing(2),
    overflow: 'auto',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));
